// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/409ec64ab183d2f8b337.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"70477141d32c59333a93","123":"587dc18133f7e305cf3c","124":"d6015f83463673b74fc4"}[chunkId] + ".chunk.js";
};